import {
  SET_COURSE_DATA,
  SET_COURSE_LOADING,
  SET_COURSE_ERROR,
  SET_CURRENT_LESSON_PROGRESS,
  SET_CURRICULUM_GRADE_AND_SUBJECT,
  SET_CURRICULUM_LIST,
  SET_SHOW_UNIT_SELECTION_SCREEN,
  SET_LAST_QUESTION,
  SET_START__LAST_QUESTION_ONE_TO_ONE,
} from './actionTypes';

const initialState = {
  courseData: null,
  loading: false,
  error: null,
  currentLessonProgress: {
    currentLessonId: '',
    currentLessonProgressPercentage: 0,
    currentLessonTotalSlides: 0,
    currentLessonMasteryScore: 0,
    currentLessonSlidesWatched: 0,
    currentLessonStartTimeStamp: Date.now(),
  },
  curriculumGradeAndSubject: {grade: '2', subject: 'Science'},
  curriculumList: null,
  showUnitSelectionScreen: false,
  lastQuestion: null,
  startLastQuestionOneToOne: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COURSE_DATA:
      return {...state, courseData: action.payload};
    case SET_COURSE_LOADING:
      return {...state, loading: action.payload};
    case SET_COURSE_ERROR:
      return {...state, error: action.payload};
    case SET_CURRENT_LESSON_PROGRESS:
      return {
        ...state,
        currentLessonProgress: {
          ...state.currentLessonProgress,
          ...action.payload,
        },
      };
    case SET_CURRICULUM_GRADE_AND_SUBJECT:
      return {...state, curriculumGradeAndSubject: action.payload};
    case SET_CURRICULUM_LIST:
      return {...state, curriculumList: action.payload};
    case SET_SHOW_UNIT_SELECTION_SCREEN:
      return {...state, showUnitSelectionScreen: action.payload};
    case SET_LAST_QUESTION:
      return {...state, lastQuestion: action.payload};
    case SET_START__LAST_QUESTION_ONE_TO_ONE:
      return {...state, startLastQuestionOneToOne: action.payload};
    default:
      return state;
  }
};

export default reducer;
